<template>
  <div class="videoCate">
    <h3>陆点壹 订单管理</h3>
    <div style="margin-top: 15px;">

      <el-input placeholder="输入订单号搜索" v-model="params.keyword" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="searchlist()"></el-button>
      </el-input>

      <el-select class="search-select" v-model="params.status" placeholder="按订单状态筛选" @change="searchlist">
        <el-option value="" label="全部" :key="0"></el-option>
        <el-option :value="0" label="待支付" :key="1"></el-option>
        <el-option :value="1" label="待发货" :key="2"></el-option>
        <el-option :value="2" label="待收货" :key="3"></el-option>
        <el-option :value="3" label="已完成" :key="4"></el-option>
        <el-option :value="4" label="系统取消" :key="5"></el-option>
        <el-option :value="7" label="手动取消" :key="6"></el-option>
      </el-select>
      <el-date-picker v-model="queryTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
        :default-time="['00:00:00', '23:59:59']" @change="dateChange">
      </el-date-picker>
      <el-button class="ml10" type="primary" @click="outexcel()">导出表格</el-button>
      <el-button class="ml10 importexcel" type="primary"><input type="file" name="file" @change="uploadFile($event)"
          accept=".csv,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />导入快递单号
      </el-button>
    </div>
    <!-- 列表 -->
    <el-table :data="list" stripe style="width: 100%" size="medium">
      <el-table-column prop="channelName" label="所属渠道" width="80"></el-table-column>
      <el-table-column prop="createTime" label="订单创建时间" width="150"></el-table-column>
      <el-table-column prop="creator" label="用户昵称" width="80"></el-table-column>
      <el-table-column prop="patientName" label="患者名字" width="80"></el-table-column>
      <el-table-column prop="patientPhone" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="doctorName" label="医生名字" width="100"></el-table-column>
      <el-table-column prop="salesmanName" label="业务员名字" width="80"></el-table-column>
      <el-table-column prop="commodity" label="商品名称" width="150"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
      <el-table-column prop="price" label="单价(元)" width="120"></el-table-column>
      <el-table-column prop="status" label="订单状态" width="100"></el-table-column>
      <el-table-column prop="payAmount" label="实付金额(元)" width="100"></el-table-column>
      <el-table-column prop="orderNumber" label="订单号" width="110"></el-table-column>
      <el-table-column prop="completeTime" label="完成时间" width="120"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="apply(scope.row.id)">查看订单详情</el-button>
          <el-button type="text" size="small" @click="showPickOrder(scope.row)"
            v-if="scope.row.status!='已完成'&&scope.row.status!='已关闭'&&scope.row.status!='已取消'">自提订单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block pagination">
      <el-pagination :current-page.sync="info.pageNo" background @current-change="changepage"
        layout="prev, pager, next, jumper" :total="info.recordCount" :page-count="info.pageCount">
      </el-pagination>

    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="outerVisible" top="8vh">
      <!-- 内容 -->
      <div class="orderdetail">
        <div class="box">
          <p>订单号：{{detail.orderNumber}}</p>
          <p>订单创建时间：{{detail.createTime}}</p>
          <p>用户昵称：{{detail.creator}}</p>
          <p>联系方式：{{detail.creatorMobile}}</p>
        </div>
        <div class="box">
          <p>购买商品：</p>
          <div class="shopinfobox flex">
            <el-image :preview-src-list="[LDY_BASEURL+detail.commodityPicture]"
              style="width: 40px; height:40px;background:#ccc;" :src="LDY_BASEURL+detail.commodityPicture"
              fit="scale-down">
              <div slot="error" class="flex ct imageerror" style="height:100%;">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div style="flex:1;padding-left:10px;">
              <div>{{detail.commodity}}<span style="padding-left:10px;">x {{detail.quantity}}</span></div>
              <div><span style="padding-right:10px;"
                  v-show="detail.specification">{{detail.specification}}</span>￥{{detail.price}}</div>
            </div>
          </div>
        </div>
        <div class="box">
          <p>商品金额：￥{{detail.amount}}</p>
          <p>运费：￥{{detail.freightFee}}</p>
          <p v-show="detail.promotionName">优惠：【{{detail.promotionName}}】<span
              v-show="detail.discountMoney">-￥{{detail.discountMoney}}</span></p>
          <p>订单总金额：￥{{detail.orderAmount}}</p>
          <p>订单状态：{{detail.status}}</p>
          <p>订单实付款：￥{{detail.payAmount}}</p>
        </div>
        <div class="box">
          <h4>快递信息</h4>
          <p>{{detail.contactPerson}} {{detail.contactPhone}}</p>
          <p>{{detail.region}} {{detail.address}}</p>
          <p>快递单号：{{detail.expressCompany}} {{detail.expressNumber}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">关闭</el-button>
        <el-button type="primary" @click="innerVisible = true">编辑快递信息</el-button>

      </div>
    </el-dialog>
    <el-dialog title="快递信息" :visible.sync="innerVisible">
      <el-form ref="form" :model="form" label-width="120px" style="width:80%;">
        <el-form-item label="快递公司">
          <el-input v-model="form.expressCompany"></el-input>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="form.expressNumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="innerVisible = false">取消</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="退款" :visible.sync="moneyVisible">
      <el-form ref="moneyform" label-width="120px" style="width:80%;">
        <el-form-item label="退款金额">
          <el-input v-model="outmoney" placeholder="金额不大于订单金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moneySubmit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认自提该订单？" :visible.sync="pickVisible" width="600px" class="i-exprot-dialog">

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pickOrder">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import creator from '../../services/delevery/api-creator.js'
  const api = creator.create('/ldy-api/pc')
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  export default {
    data() {
      return {
        list: [], // 表格数据
        info: {},
        detail: {},
        queryTime: '',
        params: {
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          status: 1,
          keyword: '', //
          pageNo: 1, // 页码
          channel: 0,
          onLineAssess: 0, //非在线评估
          commodityType: 0, //非视频订单
          userType: 1 //后台要求，跟订单列表区分开来
        },
        form: {
          expressCompany: undefined,
          expressNumber: undefined,
        },
        outerVisible: false,
        innerVisible: false,
        moneyVisible: false,
        outmoney: "", //退款金额
        pickVisible: false,
        pickInfo: {}
      }
    },
    computed: {
      ...mapGetters([
        'user',
        'LDY_BASEURL'
      ])
    },
    created() {
      // 获取列表数据
      this.getList();
    },
    methods: {
      getList(pageNo = 1) {
        this.params.pageNo = pageNo
        api.getList(this.params).then((res) => {
          this.info = res.data;
          this.list = res.data.list;
        })
      },
      // 选择日期获取新列表
      dateChange() {
        this.params.startTime = this.queryTime[0];
        this.params.endTime = this.queryTime[1];
        this.searchlist();
      },
      // 页码改变时更新列表
      changepage(val) {
        this.getList();
      },
      getInfo(id, cal) {
        api.getDetail({
          id
        }).then(res => {
          console.log("detail", res)
          this.detail = res.data;
          this.form.expressCompany = res.data.expressCompany || undefined;
          this.form.expressNumber = res.data.expressNumber || undefined;
          if (cal) cal();
        })
      },
      searchlist(val) {
        this.params.pageNo = 1;
        this.getList();
      },

      //查看
      apply(id) {
        this.getInfo(id, () => {
          this.outerVisible = true;
        });
        this.form.id = id;
      },
      //手动分账
      divide(id) {
        this.$router.push({
          path: "/order/divideSupply",
          query: {
            id: id
          }
        });
      },
      markback() {
        this.outmoney = "";
        this.moneyVisible = true;
      },
      moneySubmit() { //退款
        if (this.outmoney > this.detail.payAmount) {
          this.$message.info("金额有误");
          return;
        }
        api.mark({
          id: this.form.id,
          outmoney: this.outmoney
        }).then(rs => {
          if (rs.status == 1) {
            this.$message({
              message: rs.msg,
              type: 'success'
            });
            this.moneyVisible = false;
            this.getInfo(this.form.id);
          } else {
            this.$message(rs.msg);
          }
        })
      },
      //保存
      onSubmit(dialogForm) {
        api.save({
          ...this.form
        }).then(rs => {
          if (rs.status == 1) {
            this.$message({
              message: rs.msg,
              type: 'success'
            });
            this.getList();
            setTimeout(() => {
              this.getInfo(this.form.id);
              this.innerVisible = false;
              this.form = {
                expressCompany: undefined,
                expressNumber: undefined,
              };
            }, 600)
          } else {
            this.$message(rs.msg);
          }
        })
      },

      //导出excel
      outexcel() {
        api.outexcel(this.params).then(res => {
          // console.log(rs)
          this.saveexcel(res);
        })
      },
      saveexcel(res) {
        const link = document.createElement("a");
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI("订单记录表"));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      // 前端实现导出表格
      outportData() {
        require.ensure([], () => {
          const {
            export_json_to_excel
          } = require('@/vendor/Export2Excel.js'); //引入文件　　　　
          const tHeader = ['订单号', '用户昵称', '商品名称', '数量', '单价（元）', '订单状态', '实付金额（元）', '分享员', '订单创建时间', '完成时间']; //表头
          const filterVal = ['orderNumber', 'creator', 'commodity', 'quantity', 'price', 'status', 'payAmount',
            'sale', 'createTime', 'completeTime'
          ]; //table表格中对应的属性名　　　　　
          const data = this.formatJson(filterVal, this.list); //表格绑定数据positionData转json　　
          const fileName = "订单记录表";
          export_json_to_excel(tHeader, data, fileName);
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      uploadFile(e) {
        let file = e.target.files[0];
        if (!file) return;
        let param = new FormData(); //创建form对象
        param.append('excelFile', file); //通过append向form对象添加数据
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }; //添加请求头
        api.inexcel(param, config).then(rs => {
          this.getList();
          this.$message.success(rs.msg);
        })
      },
      //自提订单
      showPickOrder(item) {
        this.pickVisible = true
        this.pickInfo = item
      },
      pickOrder() {
        if (this.pickInfo.id) {
          api.takeOrder({
            id: this.pickInfo.id
          }).then((res) => {
            this.pickVisible = false
            this.getList()
          })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/views/delivery/ldy-delivery-list.vue